<lib-modal-container
  class="bootstrap-wrapper"
  classModalTitle="bg-azul-sunedu"
  [modalTitle]="'Locales'"
  cancelText="Cerrar"
  [noActions]="true"
  (dismiss)="handleClose()">

  <div class="m-b-25">
    <lib-grid
      variant="list"
      class="sunedu-grid-blue"
      [loading]="gridLocales.loading"
      [definition]="gridLocales.definition"
      [source]="gridLocales.source"
      [fixedLayout]="false">

      <ng-template
        libTemplate="tpl-nombreLocal"
        let-item>
        {{item.direccion}} {{item.departamento}}/{{item.provincia}}/{{item.distrito}}
      </ng-template>
      <ng-template
        libTemplate="tpl-distancia"
        let-item>
        <span *ngIf="item.distancia">{{item.distancia | number:'1.0-0'}} km</span>
        <span *ngIf="!item.distancia">-</span>
      </ng-template>
    </lib-grid>
  </div>

</lib-modal-container>
